import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from '../../config/config';
import {map} from 'rxjs/operators';

@Injectable()
export class DashboardService {

  private URL = AppSettings.API_ENDPOINT;

  constructor(private http: HttpClient) {
  }

  // fetch new admission list
  fetchNewAdmissionList(admissionData, AUTHTOKEN) {
    const params = admissionData;
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/dashboard/newAdmissionList', params, {headers}).pipe(map(res => res));
  }

  // fetch school activity
  fetchSchoolActivity(statusDate, AUTHTOKEN) {
    const params = {statusDate};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/dashboard/schooldaystatus', params, {headers}).pipe(map(res => res));
  }

  // fetch class feed
  fetchClassFeed(classId, statusDate, AUTHTOKEN) {
    const params =  {classId, statusDate: statusDate.toString()};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/dashboard/feedfordate', params, {headers}).pipe(map(res => res));
  }

  // fetch class feed
  onlineFeeCollectionHistory(date, endDate, AUTHTOKEN) {
    const params = {date, endDate, duration: date !== endDate};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/feeCollection/schoolonlinefeehistory',
      params, {headers}).pipe(map(res => res));
  }
  fetchAppMetriceData(AUTHTOKEN) {
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.get('http:// myschool.bluewings.in/bluewings/metrics/counts?v=2', {headers}).pipe(map(res => res));
  }


  // fetch dashboard data
  fetchDashboardData(getSchoolId, academicId, AUTHTOKEN) {
    const params = {getSchoolId, academicId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/dashboard', params, {headers}).pipe(map(res => res));
  }


  // for dash matrices
  fetchDashboardMetrices(schoolId, AUTHTOKEN) {
    const params = {schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/matrices', params, {headers}).pipe(map(res => res));

  }

  // for dashboard registrations
  fetchDashboardRegistration(schoolId, AUTHTOKEN) {
    const params = {schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/registration', params, {headers}).pipe(map(res => res));
  }

  // for recent broadcast
  fetchDashboardRecentBroadcast(schoolId, AUTHTOKEN) {
    const params = {schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/recentBroadcast', params, {headers}).pipe(map(res => res));
  }


  // fetch academic details
  fetchAcademicList(schoolId, AUTHTOKEN) {
    const params = {schoolId};
    const headers = new HttpHeaders().append('Content-Type', 'application/json').append('authToken', AUTHTOKEN);
    return this.http.post(this.URL + '/academiclist', params, {headers}).pipe(map(res => res));
  }

}
